import { Observable } from 'rxjs';

import { ImpersonableUser, TestUser } from './impersonation.types';

export abstract class ImpersonationService {
    /**
     * @deprecated use impersonableUsers$ instead
     */
    abstract readonly allowedTestUsers$: Observable<TestUser[]>;
    abstract readonly impersonableUsers$: Observable<ImpersonableUser[]>;
    abstract readonly onBehalfOf: string | undefined;
    abstract switchUser(userId?: string): Promise<boolean>;
}
